

export const EXTENDED_GANTT_TIMELINE_TYPE = {} as const;
